<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content class="remit-preview-dialog">
	<div *ngIf="loading" class="text-center py-5">
		<mat-spinner diameter="40"></mat-spinner>
		<p class="text-muted mt-2">Building preview from current data…</p>
	</div>
	<ng-container *ngIf="!loading && results.length === 1">
		<div *ngFor="let row of results" class="single-preview">
			<p *ngIf="row.res.subject" class="text-muted small mb-2"><strong>Subject:</strong> {{ row.res.subject }}</p>
			<ul *ngIf="row.res.warnings?.length" class="warnings-list">
				<li *ngFor="let w of row.res.warnings">{{ w }}</li>
			</ul>
			<p *ngIf="!row.res.success && row.res.message" class="text-warning">{{ row.res.message }}</p>
			<iframe
				*ngIf="row.trustedHtml"
				class="remit-frame"
				title="Remittance preview"
				[srcdoc]="row.trustedHtml"
				sandbox=""
			></iframe>
		</div>
	</ng-container>
	<mat-tab-group
		*ngIf="!loading && results.length > 1"
		animationDuration="0ms"
		class="remit-tabs"
		[selectedIndex]="activeTabIndex"
		(selectedIndexChange)="onTabChange($event)">
		<mat-tab *ngFor="let row of results" [label]="row.label">
			<div class="tab-inner">
				<p *ngIf="row.res.subject" class="text-muted small mb-2"><strong>Subject:</strong> {{ row.res.subject }}</p>
				<ul *ngIf="row.res.warnings?.length" class="warnings-list">
					<li *ngFor="let w of row.res.warnings">{{ w }}</li>
				</ul>
				<p *ngIf="!row.res.success && row.res.message" class="text-warning">{{ row.res.message }}</p>
				<iframe
					*ngIf="row.trustedHtml"
					class="remit-frame"
					title="Remittance preview"
					[srcdoc]="row.trustedHtml"
					sandbox=""
				></iframe>
			</div>
		</mat-tab>
	</mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions align="end" class="remit-actions">
	<button mat-stroked-button type="button" color="primary"
		class="remit-export-btn"
		(click)="exportXls()"
		[disabled]="!canExport()"
		matTooltip="Download as Excel spreadsheet">
		<i class="fa fa-file-excel-o"></i>&nbsp;XLSX
	</button>
	<button mat-stroked-button type="button" color="warn"
		class="remit-export-btn"
		(click)="exportPdf()"
		[disabled]="!canExport()"
		matTooltip="Download as PDF">
		<i class="fa fa-file-pdf-o"></i>&nbsp;PDF
	</button>
	<svg *ngIf="exporting" class="spinner spinner--inline" width="18px" height="18px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
		<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
	</svg>
	<span class="flex-spacer"></span>
	<button mat-button type="button" (click)="close()">Close</button>
</mat-dialog-actions>
